import { Col, Row } from "antd";

import { GROWTH_ICON, SECURITY_ICON, BULB_ICON, CLOUD_ICON } from "assets";
import { ReactSVG } from "react-svg";

import "./styles.scss";

const ServicesSection = () => {
  return (
    <section className="services-section">
      <div className="services-section-inner container">
        <p className="color-white text-center font-18">
          Unlocking Growth Exploring the Powerhouse Features of Our Business
          Solutions
        </p>
        <Row gutter={[20, 20]}>
          {services.map((service, index) => (
            <Col xs={24} sm={12} md={6} key={index}>
              <ServiceCard key={index} {...service} number={index + 1} />
            </Col>
          ))}
        </Row>
      </div>
    </section>
  );
};

export default ServicesSection;

const ServiceCard = ({ icon, title, description, number }) => (
  <div className={`service-card ${number === 2 ? "two" : ""}`}>
    <div className="number">
      <span>0{number}</span>
    </div>
    <div className="service-card-top">
      <ReactSVG src={icon} />
      <span className="sc-title" dangerouslySetInnerHTML={{ __html: title }} />
    </div>
    <div className="service-card-divider" />
    <div className="service-card-bottom">
      <p className="jakarta-sans-font font-16">{description}</p>
    </div>
  </div>
);

const services = [
  {
    icon: CLOUD_ICON,
    title: "Cloud <br/> Services",
    description: "We are dedicated to helping businesses unlock ways",
  },
  {
    icon: SECURITY_ICON,
    title: "Cybersecurity <br/> Services",
    description: "We are dedicated to helping businesses unlock ways",
  },
  {
    icon: GROWTH_ICON,
    title: "Software <br/> Development",
    description: "We are dedicated to helping businesses unlock ways",
  },
  {
    icon: BULB_ICON,
    title: "IT Consulting & <br/> IT Services",
    description: "We are dedicated to helping businesses unlock ways",
  },
];
